export { AuthGuard } from './auth.guard';



// WEBPACK FOOTER //
// ./src/app/guards/index.ts